module.exports = __webpack_public_path__ + "img/mb_sign.a89ad498.png";